import b64toBlob from 'b64-to-blob';
import Compressor from 'compressorjs';
import { storage } from '@/utils/storage';
import { fileUpload } from '@/services/daily';

export const dataURL2File = (dataurl, filename) => {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[arr.length - 1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

export const dataFile2Url = (file) => {
  if (file) {
    return URL.createObjectURL(file);
  }

  return '';
};

export const file2Base64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
};

// export const fileArr2Base64 = (files) => {
//   return Promise.all(files.map(file => file2Base64(file))).then(res => {
//     console.log('>>>>>', res);
//   })
// }

/**
 * 图片压缩
 * 1. 原图大于 30 M 的，选取后提示“选择的图片过大，请重新选择”
 * 2. 原图小于 2 M 的，使用 1080P 的参数进行压缩
 * 3. 其他大小的图片使用 0.6/1080P 的参数进行压缩
 * 4. 压缩后图片大小仍然大于 5M 的，提示“选择的图片过大，压缩失败”
 * @param {String} base64 图片数据
 * @returns
 */
export const imageCompress = (base64) => {
  const tempBase64 = base64.indexOf('base64,') > -1 ? base64.split('base64,')[1] : base64;
  const file = b64toBlob(tempBase64, 'image/jpeg');
  const fileSize = file.size;

  // 可选择最大体积
  const maxFileSize = 30 * 1024 * 1024;
  // 压缩后可用最大体积
  const maxFileCompressSuccess = 50 * 1024 * 1024;
  // 免压缩体积
  const igoreCompressSize = 0.5 * 1024 * 1024;

  if (fileSize <= igoreCompressSize) {
    return Promise.resolve(base64);
  }

  // case 1
  if (fileSize > maxFileSize) {
    return Promise.reject(new Error('选择的图片过大，请重新选择'));
  }

  // 开启质量压缩最小体积
  const minFileCompress = 1 * 1024 * 1024;
  // 分辨率最大尺寸
  const maxSize = 1080;

  // 压缩参数
  // case 2
  const configCompress = {
    maxWidth: maxSize,
    maxHeight: maxSize,
    quality: 1
  };

  // case 3
  if (fileSize >= minFileCompress) {
    configCompress.quality = 0.6;
  }

  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-new
    new Compressor(file, {
      ...configCompress,
      success(result) {
        // case 4
        if (result.size > maxFileCompressSuccess) {
          reject(new Error('选择的图片过大，压缩失败'));
        } else {
          file2Base64(result).then((res) => {
            resolve(res);
          });
        }
      },
      error(err) {
        reject(err);
      }
    });
  });
};

export async function mockUpload(params) {
  const { files, type, funcType, dotType, curTab = 1, cacheKey } = params;

  const errorMap = new Map([
    [1441415008, 1], //拆分文件格式错误
    [1441415015, 2], //拦截用户图片 青少年
    [1441415017, 2] //拦截用户图片 名人
  ]);
  await fileUpload({
    file: files,
    type: funcType
  })
    .then((i) => {
      if (type == '1') {
        storage.setItem(cacheKey || 'PICTURE', i.fileUrl);
      } else if (type == '2') {
        storage.setItem(cacheKey || 'VIDEOPIC', i.fileUrl);
      } else {
        storage.setItem(cacheKey || 'PICTURE', i.fileUrl);
      }
    })
    .catch((i) => {
      if (i?.error == 1441415008 && funcType == 0) {
        // modalUploadFailedFile({
        //   file: files
        // })
        //   .then(() => {
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 500);
        //   })
        //   .catch(() => {
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 500);
        //   });
        // 1441406007 视频帧数超出大小限制
      } else if (i?.error == 1441406007) {
        // modalUplodaFailed({
        //   title: 'Replace video and re-upload',
        //   content:
        //     'Please upload a short video no longer than 30 seconds and under 50MB in size. Supported formats include MP4, MOV, etc.',
        //   file: files
        // })
        //   .then(() => {
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 500);
        //   })
        //   .catch(() => {
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 500);
        //   });
      } else {
        // modalUplodaFailed({
        //   title: 'Upload failed',
        //   content: i.msg,
        //   file: files
        // })
        //   .then(() => {
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 500);
        //   })
        //   .catch(() => {
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 500);
        //   });
      }

      return {
        url: URL.createObjectURL('')
      };
    });
  return {
    url: URL.createObjectURL(files)
  };
}
